import { Home } from "../components/home"
import { HomeBanner } from "../components/home/banner"
import GameNavigation from "../components/navigator"

export const HomeScreen = ({match}) => {
    return (
        <>
            <GameNavigation home={true} />
            <HomeBanner />

            <Home />
        </>
    )
}